(function () {
	'use strict';

	angular
		.module('wizard-future7')
		.controller('DefaultQuizAstronautController', DefaultQuizAstronautController)

	/** @ngInject */
	function DefaultQuizAstronautController($state, $timeout, LeadService, HelperService) {
		const vm = this;

		vm.saveAstronaut = (skipStep = false) => {
			HelperService.startLoading('.quiz-container');

			if (skipStep == true) {
				vm.selectedDummyParts = {
					Body: 1,
					EyeStyle: 1,
					EyeColor: 1,
					HairStyle: 1,
					HairColor: 1,
					Glasses: 0
				}
			}

			LeadService.saveAstronautParts(vm.selectedDummyParts);

			$timeout(() => $state.go('default.quiz-questions'), 1000)
		}

		vm.nextAstronautStep = () => (vm.currentAstronautStep < vm.astronautSteps[vm.astronautSteps.length - 1].Step) ? vm.currentAstronautStep++ : vm.saveAstronaut()

		vm.prevAstronautStep = () => (vm.currentAstronautStep > 1) && vm.currentAstronautStep--

		init();

		function validateQuizStep() {
			let leadData = LeadService.getLeadData();
			let astronautName = LeadService.getAstronautName();

			if (!leadData || !astronautName)
				$state.go("default.quiz-intro")
		}

		function initVars() {
			vm.astronautSteps = [
				{
					Step: 1,
					Name: 'COR DE PELE'
				},
				{
					Step: 2,
					Name: 'OLHOS'
				},
				{
					Step: 3,
					Name: 'CABELO'
				},
				{
					Step: 4,
					Name: 'ÓCULOS'
				},
			];

			vm.currentAstronautStep = 1;

			vm.selectedDummyParts = {
				Body: 1,
				EyeStyle: 1,
				EyeColor: 1,
				HairStyle: 1,
				HairColor: 1,
				Glasses: 0
			}

			vm.breakpoints = {
				2000: {
					slidesPerView: 2,
					spaceBetween: 0
				}
			}

			vm.breakpointsMobile = {
				992: {
					slidesPerView: 6,
					spaceBetween: 0
				},
				640: {
					slidesPerView: 3.5,
					spaceBetween: 0
				},
				320: {
					slidesPerView: 2.5,
					spaceBetween: 0
				}
			}

			vm.dummyEyeColor = [
				{
					Label: "Azul",
					Color: "#36589d",
					Value: 1
				},
				{
					Label: "Verde",
					Color: "#5e8844",
					Value: 2
				},
				{
					Label: "Castanho Claro",
					Color: "#6d3d36",
					Value: 3
				},
				{
					Label: "Castanho Escuro",
					Color: "#39302c",
					Value: 4
				}
			]

			vm.dummyHairColor = [
				{ Label: "Cor 1", Color: "#221913", Value: 1 },
				{ Label: "Cor 2", Color: "#552810", Value: 2 },
				{ Label: "Cor 3", Color: "#9a6941", Value: 3 },
				{ Label: "Cor 4", Color: "#cf5326", Value: 4 },
				{ Label: "Cor 5", Color: "#bd942a", Value: 5 },
				{ Label: "Cor 6", Color: "#e8c734", Value: 6 },
				{ Label: "Cor 7", Color: "#adffd3", Value: 7 },
				{ Label: "Cor 8", Color: "#d6349b", Value: 8 }
			]
		}

		function init() {
			initVars();
			validateQuizStep();
		}

	}

}());